<template>
  <SalesDashboardCard title="Claims" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="icon">
      <span class="dashboard-card-icon dashboard-card-icon-claims" />
    </div>
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else class="row">
        <div class="col-4 d-flex flex-column">
          <span class="claim-status">New</span>
          <span class="claim-value">{{ newClaims }}</span>
        </div>
        <div class="col-4 d-flex flex-column">
          <span class="claim-status">Active</span>
          <span class="claim-value">{{ activeClaims }}</span>
        </div>
        <div class="col-4 d-flex flex-column">
          <span class="claim-status">Closed</span>
          <span class="claim-value">{{ closedClaims }}</span>
        </div>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];

export default {
  components: { Loader, SalesDashboardCard },
  data() {
    return {
      loading: false,
      newClaims: 0,
      activeClaims: 0,
      closedClaims: 0,
      selectedFilter: filters[2],
      filters,
    };
  },
  watch: {
    selectedFilter() {
      this.getCountClaims();
    },
  },
  mounted() {
    this.getCountClaims();
  },
  methods: {
    getCountClaims() {
      this.loading = true;
      axios
        .get(
          `/sales/count-jobs/claims?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          const { data } = res.data;
          this.newClaims = data.new;
          this.activeClaims = data.active;
          this.closedClaims = data.closed;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
.claim-value {
  font-size: 20px;
  font-weight: 500;
}

.claim-status {
  font-size: 12px;
  font-weight: 400;
  color: #bec0ca;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/Claims.vue